export default {"src":"/komodo/_next/static/media/webApp.b69761c3.svg","height":22,"width":26,"blurWidth":0,"blurHeight":0};